"use strict";
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports._globalThis = void 0;
/**
 * @deprecated Use globalThis directly instead.
 */
exports._globalThis = globalThis;
//# sourceMappingURL=globalThis.js.map